export default __webpack_public_path__ + "static/media/contact-2.a1efbd2c.png";